import React from 'react';
import PropTypes from 'prop-types';

import PackInfoShelfLife from './PackInfoShelfLife';
import FoodProfileBadge from 'apps/foodProfile/containers/FoodProfileBadge';

const PackInfo = ({ product = {}, showFPBadge = false }) => {
  const { packInfo, gtin } = product;

  if (!packInfo && !showFPBadge) {
    return null;
  }

  const isVegetarian = packInfo.vegetarian;
  const isFrozen = packInfo.frozen;

  return (
    <div className="fop-pack-info">
      {showFPBadge && <FoodProfileBadge barcode={gtin} />}
      {isVegetarian && (
        <div className="fop-dietary">
          <span
            className="fop-dietary-vegetarian"
            title="Suitable for vegetarians"
          />
        </div>
      )}
      {isFrozen && <span className="fop-dietary-frozen fop-life">frozen</span>}
      {!isFrozen && <PackInfoShelfLife packInfo={packInfo} />}
    </div>
  );
};

PackInfo.propTypes = {
  product: PropTypes.shape({
    packInfo: PropTypes.shape({
      vegetarian: PropTypes.bool,
      frozen: PropTypes.bool,
    }),
    gtin: PropTypes.string,
  }),
  showFPBadge: PropTypes.bool,
};

export default PackInfo;
